export default __webpack_public_path__ + "static/media/healing-roots.a5c4c319.svg";